"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_slick_1 = __importDefault(require("react-slick"));
var useBreakpoint_1 = __importDefault(require("../../hooks/useBreakpoint"));
var slidesToShow = function (breakpoint) {
    switch (breakpoint) {
        case 'sm':
            return 1;
        case 'md':
            return 2;
        case 'lg':
            return 3;
        case 'xl':
            return 4;
        default:
            return 3;
    }
};
var Slider = function (_a) {
    var children = _a.children;
    var breakpoint = useBreakpoint_1.default();
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: slidesToShow(breakpoint),
        slidesToScroll: 1,
    };
    return react_1.default.createElement(react_slick_1.default, __assign({}, settings), children);
};
exports.default = Slider;
